export default "__VITE_ASSET__Dgj9cJk2__"